export default "__VITE_ASSET__g0dnp3Dj__"